/** @jsx jsx */
import { jsx } from "theme-ui"
import * as styles from "./styles"
import React from "react"
import Tippy from "@tippyjs/react"

export interface TooltipProps {
  ariaLabel?: string
  children: React.ReactNode
  className?: string
  content: React.ReactNode | string
  placement: "top" | "left" | "right" | "bottom"
  visible?: boolean
}

export const Tooltip: React.FC<TooltipProps> = ({
  children,
  className,
  content,
  placement = "top",
  visible,
}) => {
  return (
    <Tippy
      arrow={true}
      content={content}
      delay={[0, 0]}
      duration={[0, 0]}
      inertia={true}
      offset={[0, 12]}
      placement={placement}
      sx={styles.box}
      visible={visible}
    >
      <span
        className={className}
        sx={styles.trigger}
        tabIndex={0}
        role="button"
      >
        {children}
      </span>
    </Tippy>
  )
}
